import axios from "axios/index";
import Cookies from "js-cookie";

import { checkFunction } from "./common";
// 通用拦截器
import * as commonInterceptors from "./commonInterceptors";
// color 网关拦截器
import * as colorInterceptors from "./colorInterceptors";
// 拦截相同请求
import cancelAxios from "./cancelAxios";
import { getManBaseURL, isProd } from "@/util";
import { getHost } from "@/util/host";
import { message } from "antd";

// import { TENANT_INFO, LOCAL_STORAGE } from '@/constants/index';

// 信息

// localStorage
const LOCAL_STORAGE = {
    MOCK_CACHE: "mockCache", // mock
    API_CACHE: "apiCache", // api环境
};

const xnCodes = {
    tenantCode: localStorage.getItem("tenantCode"),
    orgCode: localStorage.getItem("orgId"),
    userCode: localStorage.getItem("userCode"),
};

const header: Record<string, string> = {
    token: Cookies.get("token") || "",
    "Access-Control-Allow-Origin": "*",
    "access-control-allow-headers": "channel-xiniu",
    // FIX X-Requested-With 在color网关中报错，故屏蔽，其他网关中没用到
    "x-requested-with": "XMLHttpRequest",
};
if (Object.values(xnCodes).filter((i) => i).length) {
    header["channel-xiniu"] = JSON.stringify(xnCodes);
}

/**
 * 封装axios
 * @param baseUrl , 请求接口URL，读取环境配置的值
 * @param apiPrefix，api统一的前缀，默认为api
 * @param requestConfig
 * @param responseSuccess
 * @param responseError
 * @returns {AxiosInstance}
 */
export const baseHttp = (
    baseUrl: string,
    {
        apiPrefix = commonInterceptors.API_PRE_FIX,
        requestConfig = commonInterceptors.addRequestConfig,
        responseSuccess = commonInterceptors.addResponseSuccess,
        responseError = commonInterceptors.addResponseError,
    } = {}
) => {
    const http = axios.create({
        baseURL: baseUrl + apiPrefix, // url = base url + request url
        timeout: 5 * 60 * 1000, // request timeout
        withCredentials: true, // send cookies when cross-domain requests
        headers: header,
    });
    // http request 拦截器
    http.interceptors.request.use(
        (config) => {
            // console.log('config======', config)
            // if (VERIFY_LOGIN_INCLUDE_ROUTES.includes(location.pathname)) {
            // 	if (!isLoginPin()) {
            // 		return;
            // 	}
            // }

            // 将客户端的bd_pin（bd pin）, tenantCode(租户)重新塞到cookies中
            // Cookies.set(
            //   TENANT_INFO.BD_PIN,
            //   decodeURIComponent(decodeURI(Cookies.get(TENANT_INFO.BD_PIN))),
            //   {
            //     domain: ".jd.com",
            //   }
            // );
            // Cookies.set(
            //   TENANT_INFO.TENANT_CODE,
            //   Cookies.get(TENANT_INFO.TENANT_CODE),
            //   { domain: ".jd.com" }
            // );
            // 如果启用Mock
            const mockCache = localStorage.getItem(LOCAL_STORAGE.MOCK_CACHE);
            if (
                (config?.params?.isJApiMock ||
                    config?.data?.isJApiMock ||
                    !!mockCache) &&
                !isProd()
            ) {
                config.method = "post";
                config.baseURL =
                    "http://j-api.jd.com/mocker/data?p=153&v=POST&u=" +
                    config.url;
            }
            // 相同请求拦截
            config = cancelAxios(config);
            // 请求中添加拦截器
            return checkFunction(requestConfig, config);
        },
        (err) => Promise.reject(err)
    );

    // http response 拦截器
    http.interceptors.response.use(
        (response) => {
            response = checkFunction(responseSuccess, response);

            return response;
        },
        (error) => {
            error = checkFunction(responseError, error);
            return error;
        }
    );

    return http;
};

// color http
export const colorHttps = ({ colorAPPID = "surging_h5" } = {}) =>
    baseHttp(colorInterceptors.COLOR, {
        apiPrefix: colorInterceptors.API_PRE_FIX,
        requestConfig: (config = {}) =>
            colorInterceptors.addRequestConfig(colorAPPID, config),
        responseSuccess: colorInterceptors.addResponseSuccess,
        responseError: colorInterceptors.addResponseError,
    });

// 默认：通用 网关拦截器
export const http = baseHttp(getHost().xiaobBaseUrl); //getManBaseURL());
export const yunyingHttp = baseHttp(getHost().yunyingBaseUrl, {
    apiPrefix: commonInterceptors.API_PRE_FIX,
    requestConfig: commonInterceptors.addRequestConfig,
    responseSuccess: commonInterceptors.addResponseSuccess,
    responseError: commonInterceptors.addJDDJResponseError,
});
export const colorHttp = colorHttps();
